import dayjs from "dayjs";
import {getDaysArrayBetween} from "../lib/functions";
import {onMounted, ref} from "../.nuxt/imports";
import {useNuxtApp} from "#app";
import {TyrionApiResponse} from "../lib/interfaces/TyrionApiResponse";
import {arrow} from "@popperjs/core";

export function usePicker(minDate: number, disabled_dates: Array<Array<dayjs.Dayjs>>, date_range: {
    startDate: dayjs.Dayjs | null,
    endDate: dayjs.Dayjs | null
}) {
    const selectedDay = ref(null);
    const hoverDay = ref(null);
    const dateRange = ref<{ startDate: null | dayjs.Dayjs, endDate: null | dayjs.Dayjs }>({
        startDate: null,
        endDate: null
    });
    const holidays = ref<{
        detail: Array<{ days: Array<Date>, name: string, description: string }>,
        days: Array<string>
    }>({detail: [], days: []});

    const {$tyrionApi} = useNuxtApp();
    onMounted(() => {
        $tyrionApi.getTyrionUrl(`/api3/data/holidays.sle3.json`).then((response: TyrionApiResponse) => {
            if (response.status === 'success') {
                holidays.value = response.data.slovak;
            }
        }).finally(() => {
            // this.$tyrionApi.setCache(false).defaultCacheOptions(); TODO Cache
        })
        if (date_range) {
            dateRange.value = {
                startDate: date_range.startDate as dayjs.Dayjs,
                endDate: date_range.endDate as dayjs.Dayjs
            }
        }
        ;
    })

    const isDateDisabled = (day: dayjs.Dayjs) => {
        if (selectedDay.value !== null && day.diff(selectedDay.value) < 0) {
            return true;
        } else if (minDate && day.diff(dayjs(minDate)) < 0) {
            return true;
        }
        return false;
    }

    const isDateReservedBefore = (day: dayjs.Dayjs) => {
        if (disabled_dates && disabled_dates.length > 0) {
            const updateDate = day.format('YYYY-MM-DD');
            for (let i in disabled_dates) {
                if (disabled_dates[i][0].format('YYYY-MM-DD') === updateDate) {
                    return true;
                }

            }
        }
        return false;
    }

    const isDateReservedAfter = (day: dayjs.Dayjs) => {
        if (disabled_dates && disabled_dates.length > 0) {
            const updateDate = day.format('YYYY-MM-DD');
            for (let i in disabled_dates) {
                if (disabled_dates[i][disabled_dates[i].length - 1].format('YYYY-MM-DD') === updateDate) {
                    return true;
                }

            }
        }
        return false;
    }

    const isDateReserved = (day: string) => {
        if (!disabled_dates || disabled_dates.length === 0) return false;

        const allDates = disabled_dates.flatMap(dates =>
            dates.slice(1, -1).map(date => date.format('YYYY-MM-DD'))
        );

        return allDates.includes(day);
    };

    const isDateWeekend = (day: dayjs.Dayjs) => {
        return day.day() == 6 || day.day() == 0;
    }

    const isDateHoliday = (day: string) => {
        return holidays.value.days.includes(day);
    }

    const getHolidayName = (day: string) => {
        return holidays.value.detail.find(h => h.days.includes(day)).name;
    }

    const isDateRangeSelected = (day: dayjs.Dayjs) => {
        return (dateRange.value.startDate && dateRange.value.startDate.diff(day.date(day.date() + 1)) < 0 && dateRange.value.endDate.diff(day.date(day.date() - 1)) > 0);
    }


    const isDateBetweenStart = (day: dayjs.Dayjs) => {
        return (selectedDay.value && day.date(day.date() + 1).diff(selectedDay.value) > 0 && hoverDay.value && day.date(day.date() - 1).diff(hoverDay.value) < 0);
    }

    const getPossibleAvailableDay = (startDate: string, endDate: string) => {
        let lastAvailable = endDate;
        let previousWas = false;
        getDaysArrayBetween(startDate, endDate).forEach((d) => {
            if (!isDateReserved(d.format('YYYY-MM-DD')) && !previousWas) {
                lastAvailable = d;
            } else {
                previousWas = true;
            }
        });
        return lastAvailable;
    }

    const setSelectedDates = (dates: { arrivalDate: Date, leaveDate: Date }) => {
        dateRange.value = {startDate: dayjs(dates.arrivalDate), endDate: dayjs(dates.leaveDate)};
    }


    return {
        getPossibleAvailableDay,
        selectedDay,
        isDateReserved,
        dateRange,
        isDateDisabled,
        isDateReservedBefore,
        isDateReservedAfter,
        hoverDay,
        isDateHoliday,
        getHolidayName,
        isDateBetweenStart,
        isDateWeekend,
        isDateRangeSelected,
        setSelectedDates
    };
}


